import React, { useState } from 'react'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, SubmitHandler } from 'react-hook-form'
import { errorToast, successToast } from 'src/utils/toastService'
import { useAddParentGymMutation } from 'src/api/parentGymApi'

type IFormInput = {
  name: string
}

const formSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
})

type useAddParentGymProps = {
  successCallback: () => void
}
const useAddHook = ({ successCallback }: useAddParentGymProps) => {
  const [file, setFile] = useState<File | null>(null)
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'all',
    defaultValues: {
      name: '',
    },
  })
  const [addParentGym, { isLoading: isLoadingAddParentGym }] = useAddParentGymMutation()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setFile(e.target.files[0])
    }
  }

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    console.log(data, file)
    if (!file) {
      errorToast('Gym image is required.')
      return
    }
    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('picture', file)
    addParentGym(formData)
      .unwrap()
      .then((res) => {
        console.log(res)
        successToast('Gym added successfully.')
        reset()
        setFile(null)
        successCallback()
      })
      .catch((err) => {
        console.log(err)
        errorToast('Unable to add Gym.')
      })
  }

  return {
    file,
    handleFileChange,
    onSubmit: handleSubmit(onSubmit),
    control,
    errors,
    isLoadingAddParentGym,
  }
}

export default useAddHook
